// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2h0_l","bigColWidth":"Table_bigColWidth__1pdvz","biggerColWidth":"Table_biggerColWidth__1sQJD","row":"Table_row__E9CJn","col":"Table_col__CNae6"};